import React, { useEffect, useState, useContext } from "react";
import Box from "@mui/material/Box";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import JumboDemoCard from "@jumbo/components/JumboDemoCard/JumboDemoCard";
import SweetAlert from "app/pages/components/mui/Alerts/SweetAlert";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Slide, Grid, CircularProgress } from "@mui/material";
import Div from "@jumbo/shared/Div";
import { CustomProvider } from "app/layouts/vertical-default/VerticalDefault";
import {
    DeductRecord,
   GetNegComs
} from "backendServices/ApiCalls";
const Transition = React.forwardRef((props, ref) => {
    return <Slide direction="down" ref={ref} {...props} />;
});

function formatDayMon(dateISO) {
    try {
        const d = new Date(dateISO);
        return d.toLocaleDateString("en-GB", {
            day: "numeric",
            month: "short",
            timeZone: "Asia/Kolkata",
        });
    } catch {
        return dateISO;
    }
}

const NegativeCommissions = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { loginUserData } = useContext(CustomProvider);

    const [rows, setRows] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [alertData, setAlertData] = useState({
        show: false,
        message: "",
        variant: "",
    });

    const [confirmOpen, setConfirmOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    const formatDateTime = (isoString) => {
        const date = new Date(isoString);
        return (
            date.getFullYear() + "-" +
            String(date.getMonth() + 1).padStart(2, "0") + "-" +
            String(date.getDate()).padStart(2, "0") + " " +
            String(date.getHours()).padStart(2, "0") + ":" +
            String(date.getMinutes()).padStart(2, "0") + ":" +
            String(date.getSeconds()).padStart(2, "0")
        );
    };

    const fetchData = () => {
        setIsLoading(true);
        GetNegComs(
            (response) => {
                const processedData = response?.data?.results ?? [];
                setRows(processedData);
                setIsLoading(false);
            },
            (error) => {
                console.log(error?.response?.data);
                setIsLoading(false);
                setAlertData({
                    show: true,
                    message: error?.response?.data?.message || "Failed to fetch records",
                    variant: "error",
                });
            }
        );
    };

    const deductAction = (row) => {
        if (!row) return;
        setIsLoading(true);

        const updatedRow = {
            ...row,
            createdat: formatDateTime(row.createdat)
        };

        const params = {
            data: [updatedRow]
        };
        console.log("para", params)
        DeductRecord(
            params,
            (response) => {
                setAlertData({
                    show: true,
                    message: response?.data?.message || "Deduction processed successfully",
                    variant: "success",
                });
                setIsLoading(false);
                setConfirmOpen(false);
                setSelectedRow(null);
                fetchData(); // refresh the grid
            },
            (error) => {
                setIsLoading(false);
                setAlertData({
                    show: true,
                    message: error?.response?.data?.message || "Deduction failed",
                    variant: "error",
                });
            }
        );
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleDeductClick = (row) => {
        setSelectedRow(row);
        setConfirmOpen(true);
    };

    const confirmDeduct = () => {
        if (!selectedRow) return;
        deductAction(selectedRow);
    };

    function formatDate(dateString) {
        if (!dateString) return "";
        const date = new Date(dateString);
        if (isNaN(date)) return dateString;
        return date.toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
            year: "numeric",
        });
    }

    const columns = [
        { field: "email", headerName: "Email", width: 280, flex: 1 },
        { field: "createdat", headerName: "Commission Date", width: 160, valueFormatter: (p) => formatDate(p.value) },
        {
            field: "total_negative_usd",
            headerName: "Negative USD",
            width: 180,
            headerAlign: "center",
            align: "center",
            valueFormatter: (p) => (typeof p.value === "number" ? p.value.toFixed(2) : p.value ?? ""),
        },
        {
            field: "total_negative_eur",
            headerName: "Negative EUR",
            width: 180,
            headerAlign: "center",
            align: "center",
            valueFormatter: (p) => (typeof p.value === "number" ? p.value.toFixed(2) : p.value ?? ""),
        },
        {
            field: "action",
            headerName: "Action",
            width: 160,
            sortable: false,
            filterable: false,
            pinnable: false,
            headerAlign: "center",
            renderCell: (params) => (
                <Box sx={{ width: "100%", display: "flex", justifyContent: "flex-end", pr: 1 }}>
                    <Button
                        variant="contained"
                        size="small"
                        onClick={() => handleDeductClick(params.row)}
                    >
                        Deduct
                    </Button>
                </Box>
            ),
        },
    ];

    const gridDesign = { "& .MuiDataGrid-toolbarContainer": { "& .MuiButton-text": { fontSize: "13px !important" }, "& .MuiBadge-badge": { backgroundColor: "#074682" }, "& .MuiInput-root": { borderRadius: 2, paddingLeft: 2, overflow: "hidden" }, }, };

    return (
        <Grid
            container
            // fullWidth
            sm={12}
            xs={12}
            p={2}
            alignItems="center"
            justifyContent="center"
        >
            <Grid item sm={12} xs={12}>
                <JumboDemoCard
                    title="Negative Commissions"
                    wrapperSx={{ backgroundColor: "background.paper", pt: 0 }}
                >
                    {alertData.show && (
                        <SweetAlert alertData={alertData} setalertData={setAlertData} />
                    )}

                    <Box sx={{ height: 500, width: 1 }}>
                        <DataGrid
                            initialState={{
                                pagination: { paginationModel: { pageSize: 10 } },
                                pinnedColumns: { right: ["action"] },
                            }}
                            rows={rows}
                            getRowId={(row) => row.id}
                            columns={columns}
                            slots={{ toolbar: GridToolbar }}
                            sx={gridDesign}
                            pageSizeOptions={[10, 20, 30]}
                            loading={isLoading}
                            slotProps={{
                                toolbar: {
                                    showQuickFilter: true,
                                    quickFilterProps: { debounceMs: 500 },
                                },
                            }}
                        />
                    </Box>

                    <Dialog
                        open={confirmOpen}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={() => setConfirmOpen(false)}
                    >
                        <DialogTitle>Confirm Deduction</DialogTitle>
                        <DialogContent>
                            {selectedRow && (
                                <>
                                    Deduct negative balance for <b>{selectedRow.email}</b>?<br />
                                    USD: {selectedRow?.total_negative_usd?.toFixed(2)} | EUR:{" "}
                                    {selectedRow?.total_negative_eur?.toFixed(2)}
                                </>
                            )}
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setConfirmOpen(false)}>Cancel</Button>
                            <Button variant="contained" onClick={confirmDeduct}>
                                Deduct
                            </Button>
                        </DialogActions>
                    </Dialog>
                </JumboDemoCard>
            </Grid>
        </Grid>
    );
};

export default NegativeCommissions;
